import { Directive, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { Gtm } from '@df/module-gtm/event/gtm.event';
import { Subscription } from 'rxjs/internal/Subscription';
import { GtmListDirective } from './gtm-list.directive';

/**
 * GTM list directive
 */
@Directive({
    selector: '[gtmItem]',
    standalone: true
})
export class GtmItemDirective implements OnInit, OnChanges, OnDestroy {
    @Input({
        required: true
    })
    gtmItem!: { position: number; product: Product<IProductDataV2> };

    /**
     * Access to parent directive
     */
    private gtmListDirective = inject(GtmListDirective);

    /**
     * Visibility subscription
     */
    private subscription?: Subscription;

    ngOnInit() {
        this.gtmListDirective.register(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.gtmListDirective.onItemsChange();
        if (!this.gtmItem.product) {
            console.error('GTM item directive is missing product');
        }
        if (typeof this.gtmItem.position !== 'number') {
            console.error('GTM item directive is missing position');
        }
    }

    ngOnDestroy(): void {
        this.gtmListDirective.unregister(this);
        this.subscription?.unsubscribe();
    }

    getEventData(): Gtm.ListItem {
        return {
            ...this.gtmItem,
            ...this.gtmListDirective.gtmList
        };
    }
}
